// src/authConfig.ts
import { PublicClientApplication, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

// Get environment variables from system environment only
// Using non-null assertion as these values must be provided for the app to function
const CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || '';
const TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID || '';
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || '';

// Validate environment variables
if (!CLIENT_ID || !TENANT_ID || !REDIRECT_URI) {
  console.error('Missing required environment variables for MSAL configuration');
}

console.log("MSAL ENV (from system):", CLIENT_ID, TENANT_ID, REDIRECT_URI);

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: false
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0:
            console.error(message);
            return;
          case 1:
            console.warn(message);
            return;
          case 2:
            console.info(message);
            return;
          case 3:
            console.debug(message);
            return;
          case 4:
            console.trace(message);
            return;
        }
      }
    }
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
